import * as React from "react";
import { BoardCardWrapper } from "src/components/shared/Cards/BoardCard/BoardCard.components";
interface Props {
  value: string;
  isActive: boolean;
  onSelection: () => void;
}

const BoardCard: React.FunctionComponent<Props> = ({
  value,
  isActive,
  onSelection,
}) => {
  return (
    <BoardCardWrapper isActive={isActive} onClick={onSelection}>
      {value}
    </BoardCardWrapper>
  );
};

export default BoardCard;
